import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  Subject
} from 'rxjs';
import {
  HttpClient,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import Utils from '@iv/shared/utils';
import {
  IUserSettingsResponse,
  IUserSubscription
} from 'app/core/interfaces/user-settings.interface';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';

@Injectable({ providedIn: 'root' })
export class CommonService {

  constructor(
    private readonly http: HttpClient) { }

  private message = new Subject<any>();
  private goals = new BehaviorSubject<any>(false);

  public userSubscriptions: IUserSubscription[] = [];
  public goal = this.goals.asObservable();

  private static handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  hideChart(hide) {
    this.goals.next(hide);
  }

  sendNotification(text, type: 'success' | 'error') {
    this.message.next({'text': text, 'type': type});
  }

  getNotification(): Observable<any> {
    return this.message.asObservable();
  }

  getState(): Observable<HttpResponse<IUserSettingsResponse>> {
    return this.http.get<IUserSettingsResponse>('/user-settings/load', {observe: 'response'});
  }

  setState(tabs: any[], columnConfigs: any): any {
    const userId = Utils.getUserUuid();
    const body = JSON.stringify({uuid: userId, data: {tabs: tabs, columnConfigs: columnConfigs}});
    return this.http.post('/user-settings/save', body, {headers: {'Content-Type': 'application/json'}})
      .toPromise()
      .catch(CommonService.handleError);
  }

  public getPermissions(): Observable<PermissionTypes[]> {
    return this.http.get<PermissionTypes[]>('/permissions');
  }

  stockHasOptions(stockId?): Observable<any> {
    const params: HttpParams = new HttpParams()
      .append('stockId', stockId);
    return this.http.get<any>('/lookup/stockHasOptions', {params: params});
  }

  public getGroupSubscription(): Observable<IUserSubscription[]> {
    return this.http.get<IUserSubscription[]>('/user-settings/group');
  }
}
